import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Slider,
  TitleHeading,
  IconBox,
  About,
  Service,
  Testimonial,
  Overview,
  Faq,
  Partner,
} from "../layouts/home/index";
import { Header, Footer, TopBar, BottomBar } from "../layouts/general/index";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headers: [
        {
          id: 1,
          logoweb: "/assets/img/logo-small.png",
          names: "Home",
        },
      ],
      headingchoose: [
        {
          id: 1,
          classnames: "heading",
          title: "VIZIJOM, ZNANJEM I NAPORNIM RADOM DO CILJEVA",
          text: "Naša vizija je ponuditi jednostavna rješenja kao odgovor na kompleksne izazove digitalizacije. Spajanjem visokotehnoloških rješenja s probranim i dobro osmišljenim sadržajem, stvaramo zadovoljne korisnike i zahvalne klijente i partnere.",
          classtext: "sub-heading",
        },
      ],
      headingservice: [
        {
          id: 1,
          classnames: "heading",
          title: "NAJNOVIJI CITYX GRADOVI",
          text: "Mreža gradova se svakodnevno povećava. Do kraja 2022. godine CityX će objediniti preko 80 gradova iz tri države što će nas učiniti najvećom 'smart city' platformom 🙌 Nadamo se da je i tvoj grad dio ove lijepe priče.",
          classtext: "sub-heading",
        },
      ],
    };
  }

  render() {
    /*
    database.ref("News").once("value", (snapshot) => {
      var news = [];
      snapshot.forEach(function (childSnapshot) {
        var id = childSnapshot.id;
        var data = childSnapshot.val();
        // ...
        news.push({ id: id, title: data.title, description: data.description });
        this.setState({ news: news });
      });
    });
    */

    return (
      <div className="header-fixed page no-sidebar header-style-2 topbar-style-2 menu-has-search">
        <div id="wrapper" className="animsition">
          <div id="page" className="clearfix">
            <div id="site-header-wrap">
              <TopBar />
              {this.state.headers.map((data, idx) => (
                <Header data={data} key={idx} />
              ))}
            </div>
            <div id="main-content" className="site-main clearfix">
              <div id="content-wrap">
                <div id="site-content" className="site-content clearfix">
                  <div id="inner-content" className="inner-content-wrap">
                    <div className="page-content">
                      <div className="rev_slider_wrapper fullwidthbanner-container">
                        <div
                          id="rev-slider1"
                          className="rev_slider fullwidthabanner"
                        >
                          <Slider />
                        </div>
                      </div>
                      <div className="row-iconbox">
                        <div className="container">
                          <div className="row">
                            <div className="col-md-12">
                              <div
                                className="themesflat-spacer clearfix"
                                data-desktop={60}
                                data-mobile={60}
                                data-smobile={60}
                              />
                              {this.state.headingchoose.map((data) => (
                                <TitleHeading data={data} key={data.id} />
                              ))}
                              <div
                                className="themesflat-spacer clearfix"
                                data-desktop={42}
                                data-mobile={35}
                                data-smobile={35}
                              />
                            </div>
                          </div>

                          <IconBox />
                          <div className="row">
                            <div className="col-md-12">
                              <div
                                className="themesflat-spacer clearfix"
                                data-desktop={73}
                                data-mobile={60}
                                data-smobile={60}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <About />
                      <div className="row-services">
                        <div className="container">
                          <div className="row">
                            <div className="col-md-12">
                              <div
                                className="themesflat-spacer clearfix"
                                data-desktop={60}
                                data-mobile={60}
                                data-smobile={60}
                              />
                              {this.state.headingservice.map((data) => (
                                <TitleHeading data={data} key={data.id} />
                              ))}
                              <div
                                className="themesflat-spacer clearfix"
                                data-desktop={39}
                                data-mobile={35}
                                data-smobile={35}
                              />
                              <Service />
                              <div
                                className="themesflat-spacer clearfix"
                                data-desktop={50}
                                data-mobile={35}
                                data-smobile={35}
                              />
                              <div className="elm-button text-center">
                                <a
                                  href="/partners?type=cities"
                                  className="themesflat-button bg-accent"
                                >
                                  SVI GRADOVI
                                </a>
                              </div>
                              <div
                                className="themesflat-spacer clearfix"
                                data-desktop={73}
                                data-mobile={60}
                                data-smobile={60}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row-tabs">
                        <div className="container">
                          <div className="row">
                            <div className="col-md-12">
                              <div
                                className="themesflat-spacer clearfix"
                                data-desktop={61}
                                data-mobile={60}
                                data-smobile={60}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <Overview />
                            <Faq />
                          </div>
                        </div>
                      </div>
                      <Testimonial />
                      <Partner />
                      <div className="row-quote bg-row-1">
                        <div className="container">
                          <div className="row">
                            <div className="col-md-12">
                              <div
                                className="themesflat-spacer clearfix"
                                data-desktop={40}
                                data-mobile={60}
                                data-smobile={60}
                              />
                              {/*
                              <div className="themesflat-quote style-1 clearfix">
                                <div className="quote-item">
                                  <div className="inner">
                                    <div className="heading-wrap">
                                      <h3 className="heading">
                                        CITY<b>X</b> PRODAJA
                                      </h3>
                                    </div>
                                    <div className="button-wrap has-icon icon-left">
                                      <Link
                                        to="#"
                                        className="themesflat-button bg-white small"
                                      >
                                        <span>
                                          (+385) 1 1234 567{" "}
                                          <span className="icon">
                                            <i className="autora-icon-phone-contact" />
                                          </span>
                                        </span>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              */}
                              <div
                                className="themesflat-spacer clearfix"
                                data-desktop={31}
                                data-mobile={60}
                                data-smobile={60}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
            {this.state.headers.map((data, idx) => (
              <BottomBar data={data} key={idx} />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Home;
